// extracted by mini-css-extract-plugin
export default {"section":"Micropiles_section__3BCU0","spaceBetween":"Micropiles_spaceBetween__PyM52","rightAlign":"Micropiles_rightAlign__TRuuz"};